// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AzQRT","current":"Footer_current__hRxfz"};